export default {
  customers: {
    isLoading: false,
    error: false,
    errorMessage: null,
    data: [],
    totalPage: 0,
    count: 0
  },
  customer: {
    isLoading: false,
    error: false,
    errorMessage: null,
    data: {}
  }
};
